// 企业端详情路由
const addOrEdit = sessionStorage.getItem("currentCompany");
const linkChildren = [{
    label: "监控分析",
    attrs: {},
    url: "/enterprise/enterpriseList/detail",
    linkParent: {
      label: "监控列表",
      url: "/enterprise/enterpriseList"
    }
  },
  {
      label: "监控分析",
      attrs: {},
      url: "/enterprise/enterpriseListG/detail",
      linkParent: {
        label: "监控列表",
        url: "/enterprise/enterpriseListG"
      }
    },
  {
    label: "企业用电详情",
    attrs: {},
    url: "/enterprise/enterpriseList/detail/eledetail",
    linkParent: {
      label: "监控分析",
      url: "/monitor/caseDetail"
    }
  },
  {
    label: "方案编制",
    attrs: {},
    url: "/plan/formPlan",
    linkParent: {
      label: "方案制定",
      url: "/plan/planEdit"
    }
  },
  {
    label: "异常申报",
    attrs: {},
    url: "/enterprise/enterpriseList/detail/declare",
    linkParent: {
      label: "监控分析",
      url: "/monitor/caseDetail"
    }
  },
  {
    label: "企业限产历史记录",
    attrs: {},
    url: "/enterprise/enterpriseList/history",
    linkParent: {
      label: "监控分析",
      url: "/monitor/caseDetail"
    }
  },
  {
    label: "企业限产历史记录",
    attrs: {},
    url: "/enterprise/enterpriseListG/history",
    linkParent: {
      label: "监控分析",
      url: "/monitor/caseDetail"
    }
  },
  {
    label: "用电详细信息",
    attrs: {},
    url: "/enterprise/workshopCase/eleDetail",
    linkParent: {
      label: "监控分析",
      url: "/monitor/caseDetail"
    }
  },
  {
    label: "用电详细信息",
    attrs: {},
    url: "/enterprise/enterpriseDevice/producePollutionDevice/detail",
    linkParent: {
      label: "监控分析",
      url: "/monitor/caseDetail"
    }
  },
  {
    label: "用电详细信息",
    attrs: {},
    url: "/enterprise/enterpriseDeviceG/producePollutionDevice/detail",
    linkParent: {
      label: "监控分析",
      url: "/monitor/caseDetail"
    }
  },
  {
    //企业端告警子页面
    label: "告警名称",
    attrs: {},
    url: "/alarm/enAlarmList/nameList",
    linkParent: {
      label: "企业告警",
      url: "/alarm/enAlarmList"
    }
  },
  {
    label: "告警数量",
    attrs: {},
    url: "/alarm/enAlarmList/numList",
    linkParent: {
      label: "企业告警",
      url: "/alarm/enAlarmList"
    }
  },
  {
    label: "告警名称",
    attrs: {},
    url: "/alarm/alarmList/nameList",
    linkParent: {
      label: "告警列表",
      url: "/alarm/alarmList"
    }
  },
  {
    label: "告警数量",
    attrs: {},
    url: "/alarm/alarmList/numList",
    linkParent: {
      label: "告警列表",
      url: "/alarm/alarmList"
    }
  },
  {
    label: "污防告警",
    attrs: {},
    url: "/alarm/alarmList/governPollutionAlarm",
    linkParent: {
      label: "告警统计",
      url: "/alarm/alarmStatistics"
    }
  },
  {
    label: "污防告警详情",
    attrs: {},
    url: "/alarm/alarmList/governPollutionAlarm/details",
    linkParent: {
      label: "告警统计",
      url: "/alarm/alarmStatistics"
    }
  },
  {
    label: "历史记录",
    attrs: {},
    url: "/alarm/alarmList/governPollutionAlarm/hisMessage",
    linkParent: {
      label: "告警统计",
      url: "/alarm/alarmStatistics"
    }
  },
  {
    label: "限产异常",
    attrs: {},
    url: "/alarm/alarmList/governPollutionAlarm/limitProduction",
    linkParent: {
      label: "告警统计",
      url: "/alarm/alarmStatistics"
    }
  },
  {
    label: "设备告警",
    attrs: {},
    url: "/alarm/alarmList/otherAlarm",
    linkParent: {
      label: "告警统计",
      url: "/alarm/alarmStatistics"
    }
  },
  {
    label: "设备告警详情",
    attrs: {},
    url: "/alarm/alarmList/otherAlarm/details",
    linkParent: {
      label: "告警统计",
      url: "/alarm/alarmStatistics"
    }
  },
  {
    //企业信息管理子页面
    label: "分组管理",
    attrs: {},
    url: "/system/enEnterpriseManager/deviceTree/group",
    linkParent: {
      label: "企业信息管理",
      url: "/system/enEnterpriseManager"
    }
  },
  {
    //企业信息管理子页面
    label: "分组管理",
    attrs: {},
    url: "/system/enEnterpriseManager/deviceTree/group1",
    linkParent: {
      label: "企业信息管理",
      url: "/system/enEnterpriseManager"
    }
  },
  {
    label: "联系人管理",
    attrs: {},
    url: "/system/enEnterpriseManager/contact",
    linkParent: {
      label: "企业信息管理",
      url: "/system/enEnterpriseManager"
    }
  },
  {
    label: "设备管理",
    attrs: {},
    url: "/system/enEnterpriseManager/deviceTree",
    linkParent: {
      label: "企业信息管理",
      url: "/system/enEnterpriseManager"
    }
  },
  {
    label: "配置管理",
    attrs: {},
    url: "/system/enEnterpriseManager/monitor",
    linkParent: {
      label: "企业信息管理",
      url: "/system/enEnterpriseManager"
    }
  },
  {
    label: "新增配置管理",
    attrs: {},
    url: "/system/enEnterpriseManager/monitor/add",
    linkParent: {
      label: "企业信息管理",
      url: "/system/enEnterpriseManager"
    }
  },
  {
    label: "新建申报",
    attrs: {},
    url: "/en_declare/add",
    linkParent: {
      label: "企业申报",
      url: "/en_declare/index"
    }
  },
  {
    label: "企业申报详情",
    attrs: {},
    url: "/en_declare/detail",
    linkParent: {
      label: "企业申报",
      url: "/en_declare/index"
    }
  },
  {
    //现场勘察 2019-07-29
    label: "点位勘察",
    attrs: {},
    url: "/ExplorationAssistant/spotChecking/steps",
    linkParent: {
      label: "现场勘察",
      url: "/ExplorationAssistant/spotChecking"
    }
  },
  {
    label: "分组管理",
    attrs: {},
    url: "/ExplorationAssistant/spotChecking/equipment/group2",
    linkParent: {
      label: " 设备管理",
      url: "/ExplorationAssistant/spotChecking"
    }
  },
  {
    label: "分组管理",
    attrs: {},
    url: "/ExplorationAssistant/spotChecking/equipment/group3",
    linkParent: {
      label: " 设备管理",
      url: "/ExplorationAssistant/spotChecking"
    }
  },
  {
    label: "排污单位",
    attrs: {},
    url: "/ExplorationAssistant/spotChecking/addPolluter",
    linkParent: {
      label: "现场勘察",
      url: "/ExplorationAssistant/spotChecking"
    }
  },
  {
    label: "设备管理",
    attrs: {},
    url: "/ExplorationAssistant/spotChecking/deviceManage",
    linkParent: {
      label: "现场勘察",
      url: "/ExplorationAssistant/spotChecking"
    }
  },
  {
    label: "联系人管理",
    attrs: {},
    url: "/ExplorationAssistant/spotChecking/contact",
    linkParent: {
      label: "现场勘察",
      url: "/ExplorationAssistant/spotChecking"
    }
  },
  {
    label: "设备管理",
    attrs: {},
    url: "/ExplorationAssistant/spotChecking/equipment",
    linkParent: {
      label: "现场勘察",
      url: "/ExplorationAssistant/spotChecking"
    }
  },
  {
    label: "分组管理",
    attrs: {},
    url: "/ExplorationAssistant/spotChecking/steps/backupRelation",
    linkParent: {
      label: "现场勘察",
      url: "/ExplorationAssistant/spotChecking"
    }
  },
  {
    label: "设备管理",
    attrs: {},
    url: "/system/org/deviceTree",
    linkParent: {
      label: "组织架构管理",
      url: "/system/org"
    }
  },
  {
    label: "联系人管理",
    attrs: {},
    url: "/system/org/contact",
    linkParent: {
      label: "组织架构管理",
      url: "/system/org"
    }
  },
  {
    label: "用卡管理",
    attrs: {},
    url: "/system/org/cardmanage",
    linkParent: {
      label: "组织架构管理",
      url: "/system/org"
    }
  },
  {
    label: "配置管理",
    attrs: {},
    url: "/system/org/monitor",
    linkParent: {
      label: "组织架构管理",
      url: "/system/org"
    }
  },
  {
    label: "设备状态",
    attrs: {},
    url: "/dashboard/dashboardEnterpriseInfo/deviceState",
    linkParent: {
      label: "数据看板",
      url: "/dashboard/index"
    }
  },
  {
    label: "大气管控日历",
    attrs: {},
    url: "/plan/calendarControlFromDashboard",
    linkParent: {
      label: "数据看板",
      url: "/dashboard/index"
    }
  },
  {
    label: "污防异常查询",
    attrs: {},
    url: "/dashboard/ZWExceptionQuery",
    linkParent: {
      label: "数据看板",
      url: "/dashboard/index"
    }
  },
  {
    label: "污防异常查询 / 查看详情",
    attrs: {},
    url: "/dashboard/ZWExceptionQuery/details",
    linkParent: {
      label: "数据看板",
      url: "/dashboard/index"
    }
  },
  {
    label: "管控分析详情",
    attrs: {},
    url: "/dashboard/control",
    linkParent: {
      label: "数据看板",
      url: "/dashboard/index"
    }
  },
  {
    label: "监控分析详情",
    attrs: {},
    url: "/dashboard/monitor",
    linkParent: {
      label: "数据看板",
      url: "/dashboard/index"
    }
  },
  {
    label: "企业信息",
    attrs: {},
    url: "/dashboard/dashboardEnterpriseInfo",
    linkParent: {
      label: "数据看板",
      url: "/dashboard/index"
    }
  },
  {
    label: "生产设施状态",
    attrs: {},
    url: "/dashboard/DashboardEnterpriseInfoA",
    linkParent: {
      label: "数据看板",
      url: "/dashboard/index"
    }
  },
  {
    label: "污防设施状态",
    attrs: {},
    url: "/dashboard/DashboardEnterpriseInfoB",
    linkParent: {
      label: "数据看板",
      url: "/dashboard/index"
    }
  }, {
    label: "区域负荷统计", //测试子母路由的跳转实现
    attrs: {},
    url: "/dashboard/areaenCount",
    linkParent: {
      label: "数据看板",
      url: "/dashboard/index"
    }
  },
  {
    label: "生产设备状态",
    attrs: {},
    url: "/en_dashboard/produceDevice",
    linkParent: {
      label: "数据看板",
      url: "/en_dashboard/index"
    }
  },
  {
    label: "污防告警信息",
    attrs: {},
    url: "/en_dashboard/pollutionAlarm",
    linkParent: {
      label: "数据看板",
      url: "/en_dashboard/index"
    }
  },
  {
    label: "异常管控",
    attrs: {},
    url: "/en_dashboard/abnormalControl",
    linkParent: {
      label: "数据看板",
      url: "/en_dashboard/index"
    }
  },
  {
    label: "产线模拟图",
    attrs: {},
    url: "/bigScreen/editor",
    linkParent: {
      label: "组件编辑",
      url: "/bigScreen/list"
    }
  },
  {
    label: "产线模拟图",
    attrs: {},
    url: "/monitor/chanxiantu",
    linkParent: {
      label: "组件编辑",
      url: "/monitor/chanxiantu"
    }
  },
  {
    label: "效果预览",
    attrs: {},
    url: "/bigScreen/view",
    linkParent: {
      label: "组件编辑",
      url: "/bigScreen/list"
    }
  }
];

export default linkChildren;



// WEBPACK FOOTER //
// ./src/layout/model/notInMenuRouteEn.js